export default __webpack_public_path__ + "static/media/listing_beds.14a0933d.svg";